<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">{{showTitle}}</v-card-title>
      <v-card-text class="mt-3 body-2">
        <p v-html="checkLists"></p>
        <div v-if="dateCol === 'overallAlignmentCol'">
          <div class="d-flex flex-row">
            <p class="mb-0 pt-3 pr-2">Alignment Sync Date - </p>
            <v-text-field
              class="edit-date-box"
              v-model="alignmentSyncDate"
              outlined
              dense
              hide-details
              @input="checkDate(alignmentSyncDate)"
              @keyup.enter="checkDate(alignmentSyncDate)"
            >
            </v-text-field>
            <div class="date-picker-inner">
              <date-picker
                className="input-field"
                :options="{theme: 'icon'}"
                :status="dateCal"
                @changeDate="setDateFromPicker"
              />
            </div>
          </div>
          <span class="text-danger ma-0 pt-1" v-if="alignementSyncErr">Please enter valid Alignment Sync Date</span>
        </div>
        <div v-if="dateCol === 'approvedByAdminCol'">
          <p class="subtitle-1 font-weight-bold mb-2">Please check and confirm these steps below</p>
          <ol class="text-left body-1">
            <li>Stats and Sentiment Due Date - <b>{{item.SentimentDateCol && item.SentimentDateCol.status ? 'Ready' : 'Not Ready!'}}</b></li>
            <li>Completed by CC - <b>{{item.CCReadyDeckCol && item.CCReadyDeckCol.status ? 'Ready' : 'Not Ready!'}}</b></li>
            <li>Completed by AM - <b>{{item.AMReadyDeckCol && item.AMReadyDeckCol.status ? 'Ready' : 'Not Ready!'}}</b></li>
            <li>Alignment Sync - <b>{{item.overallAlignmentCol && item.overallAlignmentCol.status ? `Ready (${item.overallAlignmentCol.alignmentDate})`  : 'Not Ready!'}}</b></li>
          </ol>
          <div class="pl-2" v-if="item.SentimentDateCol && item.SentimentDateCol.reviewDateURL">
            <p class="mb-0 subtitle-2">Review Deck URL</p>
            <a target="_blank" :href="item.SentimentDateCol.reviewDateURL">{{item.SentimentDateCol.reviewDateURL}}</a>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="!isConfirmAllowed">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
import moment from 'moment'
import utils from '@/utils'
import DatePicker from '@/components/scoped/custom/DatePicker'
import reviewMeetingConfig from './config'
export default {
  name: 'ReviewMeetingChecklistModal',
  props: {
    value: Boolean,
    item: Object,
    dateCol: String
  },
  components: {
    DatePicker
  },
  data () {
    return {
      alignmentSyncDate: '',
      alignementSyncErr: false,
      checkLists: ''
    }
  },
  async mounted() {
  },
  computed: {
    // reviewDeckURLErrors() {
    //   const errors = [];
    //   if (!this.$v.reviewDeckURL.$dirty) return errors;
    //   !this.$v.reviewDeckURL.required && errors.push('This field is required.');
    //   return errors;
    // }
    showTitle() {
      if (this.dateCol === 'overallAlignmentCol') {
        return 'Confirm Date'
      } else if (this.dateCol === 'AMReadyDeckCol') {
        return 'Release deck to admin for vetting'
      }
      return 'Confirm Checklists'
    },
    isConfirmAllowed() {
      if (this.dateCol === 'approvedByAdminCol') {
        return this.item.SentimentDateCol.status && this.item.CCReadyDeckCol.status && this.item.AMReadyDeckCol.status && this.item.overallAlignmentCol.status
      }
      return true
    }
  },
  watch: {
    value: function(newValue) {
      this.alignmentSyncDate = utils.func.formatCustomDate(moment(), 'DD/MM/YYYY')
      this.checkLists = ''
      this.alignementSyncErr = false
      if (this.dateCol === 'CCReadyDeckCol') {
        this.checkLists = reviewMeetingConfig.reviewMeetingChecklists.completedByCC.html
      }
      if (this.dateCol === 'AMReadyDeckCol') {
        this.checkLists = reviewMeetingConfig.reviewMeetingChecklists.completedByAM.html
      }
    }
  },
  methods: {
    checkDate(dateVal) {
      this.alignementSyncErr = true
      if (utils.func.isDateFormatValid(dateVal) || !dateVal) {
        this.alignementSyncErr = false
      }
    },
    setDateFromPicker(value) {
      this.alignmentSyncDate = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.checkDate(this.alignmentSyncDate)
    },
    save() {
      if (this.dateCol === 'overallAlignmentCol') {
        this.alignementSyncErr = false
        // if alignment sync date, check for date validation
        if (this.alignementSyncErr || !this.alignmentSyncDate) {
          this.alignementSyncErr = true
          return
        } else {
          this.item[this.dateCol].alignmentDate = this.alignmentSyncDate
        }
      }
      this.$emit('saveClicked', this.item)
      this.$emit('input')
    },
    close() {
      this.item[this.dateCol].status = false
      this.$emit('closeClicked', this.item)
      this.$emit('input')
    }
  }
};
</script>
<style scoped>
  .edit-date-box {
    max-width: 200px;
  }
  .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// ReviewMeetingChecklistModal.vue?5ddae2bc